import React from 'react';
import type { Job } from '../../types/career';
export function JobChips({
  job,
  className = ''
}: {
  job: Job;
  className?: string;
}) {
  const chips = [job.department, job.location, job.type, job.mode];
  return <ul className={`flex flex-wrap gap-2 ${className}`} data-id="element-240" data-mp="1hrqvqbycaa4u">
      {chips.map(chip => <li key={chip} className="rounded-full bg-white px-3 py-1 text-[13px] font-medium text-ink ring-1 ring-canvas-line" data-id="element-241" data-mp="1dqx7tikwcvby">
          {chip}
        </li>)}
    </ul>;
}